module.exports = __webpack_public_path__ + "media/images/vp/slider.index.01-1ea3bf94fad2b3ba0f00756a5c41338b.jpg";